export default function PainPoints() {
  const painPoints = [
    {
      icon: 'ri-team-line',
      title: '團隊氣氛不錯',
      subtitle: '但執行力不足',
      description: '感情好不等於能做事'
    },
    {
      icon: 'ri-building-line',
      title: '部門之間有牆',
      subtitle: '互相推責任',
      description: '各自為政難以協作'
    },
    {
      icon: 'ri-user-star-line',
      title: '主管想帶人',
      subtitle: '但帶得很累',
      description: '領導力需要被訓練'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '員工有能力',
      subtitle: '卻不夠主動',
      description: '缺乏承擔與突破意識'
    },
    {
      icon: 'ri-camera-line',
      title: '想做團建',
      subtitle: '但不想只是吃喝拍照',
      description: '要的是真正的改變'
    }
  ];

  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-16">
          企業來找我們，通常是因為：
        </h2>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
          {painPoints.map((point, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${point.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-2">{point.title}</h3>
              <p className="text-white font-semibold mb-3">{point.subtitle}</p>
              <p className="text-gray-400 text-sm">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
